<template>
    <main class="server">
        <div class="title">
            <div v-for="(i,index) in list" @click="current=index" :class="['item',{active:current==index}]">
                <!-- <v-image :src="i.picture" width="100%" height="100%"></v-image> -->
                <img :src="i.picture" alt="">
                <div class="text">{{i.cateName}}</div>
            </div>
        </div>
        
        <div class="context">
            <div class="ident"><span></span><span></span></div>
            <div v-html="list[current].productServerContext"></div>
        </div>
    </main>
</template>
<style lang="less" scoped>
	@red: #e60012;
    .server {
        width: 1200px;
        margin: 0 auto 40px;
        padding-bottom: 10px;
        display: flex;
        position: relative;

        .title {
            position: absolute;
            top: 16px;
            z-index: 6;

            .item {
                width: 140px;
                height: 70px;
                margin-bottom: 10px;
                position: relative;
                cursor: pointer;
                transition: all .2s;
                
                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0.8;
                }
                
                .text {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    font-size:18px;
                    font-weight:400;
                    color:#FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all .2s;
                    
                }

                &.active {
                    width: 200px;
                    height: 100px;

                    .text {
                        font-weight: bold;
                        font-size: 24px;
                        letter-spacing: 4px;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);   
                    }
                }
            }
        }

        .context {
            width:1050px;
            min-height:460px;
            background:#EFEFEF;
            padding: 64px 66px 64px 69px;
            margin-left: 150px;
            font-size:14px;
            font-weight:400;
            color:#353535;
            text-align: left;
            position: relative;
                
            .ident {
				display: flex;
				position: absolute;
				top: 34px;
				left: 69px;
							
				span {
					width: 48px;
					height: 4px;
					background-color: #353535;

					&:not(:last-child) {
					    background-color: @red;
					}
								
				}
            }
        }

    }

    @media screen and (max-width: 1360px) {
        
        .server {
            width: 100%;
            margin: 0 auto 40px;
            padding-bottom: 10px;
            display: flex;
            position: relative;

            .title {
                position: absolute;
                top: 16px;
                z-index: 6;

                .item {
                    width: 140px;
                    height: 70px;
                    margin-bottom: 10px;
                    position: relative;
                    cursor: pointer;
                    transition: all .2s;
                    
                    img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        opacity: 0.8;
                    }
                    
                    .text {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        font-size:18px;
                        font-weight:400;
                        color:#FFFFFF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all .2s;
                        
                    }

                    &.active {
                        width: 200px;
                        height: 100px;

                        .text {
                            font-weight: bold;
                            font-size: 24px;
                            letter-spacing: 4px;
                            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);   
                        }
                    }
                }
            }

            .context {
                width:100%;
                min-height:460px;
                background:#EFEFEF;
                padding: 64px 66px 64px 69px;
                margin-left: 150px;
                font-size:14px;
                font-weight:400;
                color:#353535;
                text-align: left;
                position: relative;
                    
                .ident {
                    display: flex;
                    position: absolute;
                    top: 34px;
                    left: 69px;
                                
                    span {
                        width: 48px;
                        height: 4px;
                        background-color: #353535;

                        &:not(:last-child) {
                            background-color: @red;
                        }
                                    
                    }
                }
            }

        }
    }
</style>
<script>
    export default {
        data() {
            return {
                current:0,
                list:[{}]
            }
        },
        methods: {
            getServiceList(){
                let that = this;
                ajax.call(this, {
					url: "/bloc/productService/list/language",
                    data: {},
                    s(res) { 
                        that.list = res.data.map(v => {
							return {
								picture: v.picture,
								cateName:v.cateName,
                                productServerContext: v.productServerContext,
                                
							}
                        });
                    }
                    
                });
            },
            
        },
        mounted() {
            this.getServiceList();
        },
        watch: {
			"$root.language"() {
				this.getServiceList();
			},

		}
    }
</script>